import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class CategoriasBestbuyService extends ApiService {
    entityType = EntityType.BESTBUY_CATEGORIA;
    url = 'api/marketplace/bestbuy/categorias/';
}
